var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"tooltip"},'div',_vm.$props,false),[_vm._t("default"),(_vm.content)?_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.content))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }